module.exports = __webpack_public_path__ + "static/media/N.2ea1caba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/N.jpg
// module id = 82
// module chunks = 0